import { Box, Grid, Typography } from "@mui/material";
import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { FaFilePdf } from "react-icons/fa6";
import { FaFileImage } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";
import { CloudDownload, CloudUpload } from "lucide-react";
interface MultipleFileUploadProps {
  control: any;
  rules: any;
  errors: any;
  errorMessageStyles?: any;
  helperTextStyles?: any;
  helperText?: string;
  onBlurHandler?: any;
  name: string;
  label: string;
  variant?: any;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  fileUploadEvent?: any;
  inputRef?: any;
  deleteSelectedFile?: any;
  maxLimit?: number;
  accept?: string;
  selectedFiles?: Array<any>;
  handleFileChange?:any;
}
const FileUpload: FC<MultipleFileUploadProps> = ({
  control,
  name,
  rules,
  fileUploadEvent,
  inputRef,
  accept,
  selectedFiles,
  handleFileChange
}) => {
  return (
    <Box>
      <Controller
        control={control}
        name={name}
        defaultValue={""}
        rules={rules}
        render={({ field: { onBlur, value, onChange } }) => (
          <Box
            className="fileupload-view"
            sx={{ width: "100%", height: "auto" }}
          >
            <Box
              className="row justify-content-center m-0"
              sx={{ width: "100%", height: "100%" }}
            >
              <Box width={"100%"} height="100%">
                <Box width={"100%"} height="100%">
                  <Box width={"100%"} height="100%">
                    <Box width={"100%"} height="100%">
                      <Box
                        width={"100%"}
                        height="100%"
                        sx={{
                          backgroundColor: "#E5EAEF",
                          p: "4.5px",
                          borderRadius: "6px",
                          position: "relative",
                        }}
                      >
                        <Box
                          className="file-upload-box group bg-[#f0f2f7] relative border border-dashed border-[#b6bd1] min-h-[90px] overflow-hidden p-[10px] flex flex-col items-center justify-center font-[400]  w-full rounded-md"
                          sx={{
                            backgroundColor: "#E5EAEF",
                            p: "6.5px",
                            borderRadius: "6px",
                            height: "20px",
                            border: "1px dashed #003366",
                            width: "100%",
                          }}
                        >
                          <CloudUpload className="size-14 text-gray-500 mt-2" />

                          <div className="flex flex-row items-center h-full w-full">
                            <input
                              type="file"
                              ref={inputRef}
                              onChange={(e) => {
                                fileUploadEvent(e?.target?.files);
                                
                                // handleFileChange?.(e?.target?.files)
                                onChange(e);
                              }}
                              accept={`${accept} application/pdf;application/xlsx;application/xls;application/vnd.ms-excel;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`}
                              className="file-upload-input absolute w-full h-full top-0 left-0 opacity-0 cursor-pointer"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: "0%",
                                left: "0%",
                                opacity: 0,
                                cursor: "pointer",
                              }}
                              value={value}
                              onBlur={onBlur}
                              // onChange={InputChange}
                            />
                            <Box
                              sx={{
                                height: "100%",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                className="text-[15px]"
                                sx={{
                                  fontSize: "15px",
                                  color: "#003366",
                                  fontWeight: "600",
                                }}
                              >
                                Drag and drop or{" "}
                                <span
                                  className="file-link underline underline-offset-2 text-[15px]  group-hover:text-[#1976D2] "
                                  style={{
                                    textDecoration: "underline",
                                    textUnderlineOffset: "4px",
                                  }}
                                >
                                  Choose your files
                                </span>
                              </Typography>
                              {/* {!!helperText ? (
                              <Typography

                              // className={twMerge(
                              //   " flex items-center gap-1 font-normal",
                              //   helperTextStyles
                              // )}
                              >
                                <PiWarningCircleFill
                                  size={12}
                                  className="text-[11px]"
                                />
                                {helperText}
                              </Typography>
                            ) : (
                              <></>
                            )} */}
                            </Box>
                          </div>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      />
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        display={"flex"}
        flexDirection={"row"}
        flexWrap={"wrap"}
        mt={1}
      >
        {selectedFiles &&
          selectedFiles.map((data, index) => {
            const { filename, filetype, fileimage, datetime, filesize } = data;
            return (
              <Grid
                item
                xs={12}
                sm={12}
                p={"4px"}
                className="flex col-span-1 gap-x-1 border rounded-md w-full"
                key={index}
              >
                <Box
                  display="flex"
                  justifyContent={"start"}
                  alignItems={"start"}
                  rowGap={"20px"}
                  columnGap={"20px"}
                >
                  {filename.match(/.(jpg|jpeg|png|gif|svg)$/i) ? (
                    <Box
                      sx={{ width: "70px", height: "70px" }}
                      className="file-image w-[70px] h-[60px] rounded-tl-md bg-[#eaecf1] p-1 flex items-center justify-center "
                    >
                      <FaFileImage size={40} />
                    </Box>
                  ) : filename.match(/.(pdf|doc|docx)$/i) ? (
                    <Box
                      sx={{ width: "70px", height: "70px" }}
                      className="file-image w-[70px] h-[60px] rounded-tl-md bg-[#eaecf1] p-1 flex items-center justify-center "
                    >
                      <FaFilePdf size={50} />
                    </Box>
                  ) : filename.match(/.(xls|xlsx)$/i) ? (
                    <Box
                      sx={{ width: "70px", height: "70px" }}
                      className="file-image w-[70px] h-[60px] rounded-tl-md bg-[#eaecf1] p-1 flex items-center justify-center "
                    >
                      <RiFileExcel2Fill size={40} />
                    </Box>
                  ) : (
                    <></>
                  )}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      {!!filename && filename.length > 45
                        ? filename.slice(0, 44) + "..."
                        : filename}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {filesize}
                    </Typography>

                    {/* <p>
                                 
                                </p>
                       
                                <p>
                                  <span>Size : {filesize}</span>
                                </p>
                                <Box className="file-actions mt-1">
                                  <button
                                    type="button"
                                    className="file-action-btn"
                                    // onClick={() => DeleteSelectFile(id)}
                                    onClick={() => deleteSelectedFile?.(id)}
                                  >
                                    Delete
                                  </button>
                                </Box> */}
                  </Box>
                </Box>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default FileUpload;
